import { useSession } from 'next-auth/react';
import { useEffect, useRef } from 'react';
import GrispiChatMessageUpdatesController from '../../components/GrispiNews/Subscription/GrispiChatMessageUpdatesController';
import GrispiNewsSubscribeTicketTabsController from '../../components/GrispiNews/Subscription/GrispiNewsSubscribeTicketTabsController';
import { checkGrispiNewsIsAlive } from '../../services/grispi-news/grispi-news-services';
import { getGrispiNewsStore } from '../../utils/store/getStore';
import { getTabId } from '../../utils/tabId';
import { GrispiNewsResponseType } from './grispi-news.type';

export const grispiNewsApiUrl = `${process.env.NEXT_PUBLIC_GRISPI_NEWS_URL}`;

const GrispiNewsController = () => {
    const {
        data: {
            accessToken: token,
            userInfo: { userId }
        }
    } = useSession();

    const sseRef = useRef<EventSource>(null);
    const audioEl = useRef<HTMLAudioElement>(null);

    const tabId = getTabId();

    useEffect(() => {
        if (!sseRef.current && tabId && token) {
            try {
                sseRef.current = new EventSource(`${grispiNewsApiUrl}/subscriptions/sse?sid=${tabId}&token=${token}`);
            } catch (error) {
                console.error('Grispi news connection failed.', error);
            }
        }
    }, [tabId, token]);

    useEffect(() => {
        if (sseRef.current) {
            sseRef.current.onopen = () => {
                getGrispiNewsStore().setGrispiNewsApiStatus(true);
            };

            sseRef.current.onmessage = async function (evt: MessageEvent<string>) {
                if (evt.data === 'hb') return;
                try {
                    const data: GrispiNewsResponseType = JSON.parse(evt.data);
                    if (!data || !data.c) return console.log('Grispi news channel not found!: ', evt.data);
                    // console.log('Grispi news received:', data);
                    if (data.u === userId) {
                        // console.log('Grispi news notification from me!', data);
                        return;
                    }
                    if (data.d?.a === 'u' && !data.d?.fields?.length) {
                        //this means that someone reply the ticket without any changes
                        // console.log('Grispi news notification ticket updated without fields!', data);
                        return;
                    }
                    //ticket news
                    getGrispiNewsStore().addNotification(data);
                    if (audioEl.current) {
                        setTimeout(() => {
                            audioEl.current.play();
                        }, 100);
                    }
                } catch (err) {
                    console.log('Grispi news as string: ', evt.data, err);
                }
            };

            sseRef.current.onerror = async () => {
                // console.error('EventSource failed:', err);
                await checkGrispiNewsIsAlive().catch(() => {
                    console.error('Grispi news api not alive.');
                    sseRef.current.close();
                });
                getGrispiNewsStore().setGrispiNewsApiStatus(false);
            };
        }
        return () => {
            sseRef.current?.close();
            sseRef.current = null;
        };
    }, [tabId, userId]);

    return (
        <>
            <audio ref={audioEl} src="https://bigsoundbank.com/UPLOAD/ogg/1111.ogg" preload="auto" />
            <GrispiNewsSubscribeTicketTabsController />
            <GrispiChatMessageUpdatesController />
        </>
    );
};

export default GrispiNewsController;
